import storeInfo from '../store'
import { NotificationType } from './types'

export const getNotifications = () => (): NotificationType => {
  const { notifications } = storeInfo.store.getState()
  return notifications
}